import { ActionType } from '../action';
import { SET_COM_REFS } from '../action/constants';

export default (state: Object = {}, action: ActionType): Object => {
  let res: Object = { ...state };
  if (action.type === SET_COM_REFS) {
    res = {
      ...state,
      ...action.comRefs,
    };
  }
  return res;
};
